import { render } from "./Usuarios.vue?vue&type=template&id=2cd5b06b"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"

import "./Usuarios.vue?vue&type=style&index=0&id=2cd5b06b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__